export const config = {
  axes: {
    y: {
      show: true,
      tickSizeInner: 0,
      tickLineColour: "white",
      domainColour: "white",
      textColour: "grey",
      fontSize: 12,
      fontWeight: 400,
      offset: -20,
      format: ".1f",
      label: {
        colour: "grey",
        fontSize: 14,
        fontWeight: 400,
        margin: -60,
        text: "Forward 21d Price Return",
      },
      background: {
        color: { OaR: "#98FB98", VaR: "#F19CBB" },
        selectedColor: "#98FB98",
        offset: { y: 7, x: 53 },
      },
    },
    x: {
      show: true,
      tickSizeInner: 0,
      tickLineColour: "white",
      domainColour: "white",
      textColour: "grey",
      fontSize: 12,
      fontWeight: 400,
      label: {
        colour: "grey",
        fontSize: 14,
        fontWeight: 400,
        margin: 40,
        text: "V-Score",
      },
    },
  },
  layout: {
    margin: {
      top: 100,
      right: 50,
      bottom: 60,
      left: 100,
    },
  },
  svg: { Background: "#ffffff", border: "none" },
  border: { stroke: "#f6f6f6", strokeWidth: 1 },
  header: {
    text: "OarVar",
    colour: "#CBA266",
    fontSize: 14,
    fontWeight: 600,
    margin: { left: 10, top: 20 },
  },
  refLine: {
    stroke: "grey",
    strokeWidth: 2,
    label: {
      x: { text: "Average", fontSize: 10, fontWeight: 400, color: "#000000" },
      y: { text: "Average", fontSize: 10, fontWeight: 400, color: "#000000" },
    },
  },
  circle: { radius: 4, strokeWidth: 1 },
  triangle: {
    size: 36,
  },
  tooltips: {
    active: true,
    hovercolour: "#182235",
    text: {
      label: { fontSize: 10, fontWeight: 600, color: "#000000" },
      content: { fontSize: 10, fontWeight: 400, color: "#000000" },
      seperator: { fontSize: 10, fontWeight: 400, color: "#000000" },
    },
    box: {
      width: 400, //296,
      height: 100,
      fill: "#DFDFDF",
      stroke: "#DFDFDF",
      strokeWidth: 1,
      radius: 4,
    },
    triangle: {
      size: 64,
      marginTop: -1,
      mousetoboxgap: 20,
    },
    table: { padding: 4, border: "none", backgroundColor: "none" },
    tr: { seperator: ":" },
    td: {
      align: { label: "left", content: "left" },
      padding: {
        label: { left: 10, right: 5 },
        content: { left: 5, right: 10 },
      },
    },
  },
};
